import { render, staticRenderFns } from "./ResidentView.vue?vue&type=template&id=63f669f7"
import script from "./ResidentView.ts?vue&type=script&lang=ts&external"
export * from "./ResidentView.ts?vue&type=script&lang=ts&external"
import style0 from "./ResidentView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports